import _ from 'lodash/toString';

export default function isEqualString(value1, value2) {
  return _.toString(value1) === _.toString(value2);
}



// WEBPACK FOOTER //
// ./app/utils/is-equal-string.js